import fetch from "isomorphic-unfetch";
import { isServer } from "../utils/is-server";

const onServer = isServer();
let cached = {};

export function useFetch(namespace, url) {
  const GETByID = async id => {
    if (!cached[namespace] || onServer) {
      await GET();
    }
    return cached[namespace].find(x => x.id === id);
  };

  const GET = async () => {
    if (!cached[namespace] || onServer) {
      const res = await fetch(url);
      const json = await res.json();
      cached[namespace] = json;
    }
    return cached[namespace];
  };

  return { GET, GETByID };
}
